import * as Icons from './icons';

/* @ngInject */
export default function IconConfig($mdIconProvider) {
    Object.keys(Icons).forEach((iconKey) => {
        const icon = Icons[iconKey];
        $mdIconProvider.icon(icon.name, icon.url);
    });
}
